import type { ReactNode } from 'react';
import { cva, type VariantProps } from 'class-variance-authority';
import { cn } from '@perch/ui-tokens';

const sectionLabelVariants = cva(
  'text-[11px] font-bold uppercase tracking-widest leading-normal',
  {
    variants: {
      variant: {
        default: 'text-stone-400 dark:text-stone-500',
        emerald: 'text-emerald-600 dark:text-emerald-400',
        amber: 'text-amber-600 dark:text-amber-400',
        coral: 'text-[var(--coral)]',
      },
    },
    defaultVariants: {
      variant: 'default',
    },
  }
);

interface SectionLabelProps extends VariantProps<typeof sectionLabelVariants> {
  children: ReactNode;
  className?: string;
}

export function SectionLabel({ children, variant, className }: SectionLabelProps) {
  return (
    <p className={cn(sectionLabelVariants({ variant }), className)}>
      {children}
    </p>
  );
}

export { sectionLabelVariants };
